export * from './core/processos/processoAntecedenteService';
export * from './core/processos/processoDocumentoService';
export * from './core/dashboard/dashboard.services';
export { default as ConsultaDinamicaService } from './core/consultadinamica/consultaDinamica.service';
export { default as CaixaFiliais } from './core/caixafiliais/CaixaFiliaisService';
